import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfirmComponent } from "./confirm.component";
import { TranslateModule } from "@ngx-translate/core";
import { OneTimePasswordModule } from "@app/shared/one-time-password/one-time-password.module";
import { UtilsModule } from '@app/shared/utils/utils-module';

@NgModule({
    declarations: [ConfirmComponent],
    imports: [CommonModule, TranslateModule, OneTimePasswordModule, UtilsModule],
    exports: [ConfirmComponent],
})
export class ConfirmModule {}
